import navbar from '@/components/NavBar.vue';
import Stepper from '@/components/wizardTreatment/stepper/index.vue';
import StepperNavigation from '@/components/wizardTreatment/stepper-navigation/index.vue';
import ProductResume from '@/components/wizardTreatment/productResume/index.vue';
import treatmentPlanService from '@/services/treatmentPlanService';
import { mapState, mapGetters, mapActions } from 'vuex';
import moment from 'moment-timezone';

export default {
  name: 'treatment-step-three',
  components: {
    navbar,
    Stepper,
    StepperNavigation,
    ProductResume,
  },
  props: [],
  data() {
    return {

    };
  },
  computed: {
    ...mapGetters('treatmentStepper', ['treatmentPlan']),
    ...mapState('Plantation', ['currentPlantation', 'isPlantationSelected']),
    ...mapState('Plans', ['currentPlanId']),
  },

  methods: {
    validateForm() {
      if (typeof this.treatmentPlan.description === 'undefined' || this.treatmentPlan.description === '') {
        this.$f7.dialog.alert(this.$t('treatment.treatmentPlan.treatmentCreatePlan.description_validation'));
        return false;
      }
      if (typeof this.treatmentPlan.dose_type === 'undefined' || this.treatmentPlan.dose_type === '') {
        this.$f7.dialog.alert(this.$t('treatment.treatmentPlan.treatmentCreatePlan.dose_type_validation'));
        return false;
      }
      if (typeof this.treatmentPlan.agent === 'undefined' || this.treatmentPlan.agent === '') {
        this.$f7.dialog.alert(this.$t('treatment.treatmentPlan.treatmentCreatePlan.agent_validation'));
        return false;
      }
      if (!this.treatmentPlan.products || this.treatmentPlan.products.length == 0) {
        this.$f7.dialog.alert(this.$t('treatment.treatmentPlan.treatmentCreatePlan.emptyProducts'));
        return false;
      }

      return true;
    },
    async save() {
      if (this.validateForm()) {
        const payload = {
          plantation: this.currentPlantation.id,
          description: this.treatmentPlan.description,
          init_date: moment(this.treatmentPlan.init_date).format('YYYY-MM-DD'),
          end_date: moment(this.treatmentPlan.end_date).format('YYYY-MM-DD'),
          period: this.treatmentPlan.period,
          dose_type: this.treatmentPlan.dose_type,
          agent: this.treatmentPlan.agent,
          products: this.treatmentPlan.productResume.map((product, index) => {
            const periods = [];
            for (const prop in this.treatmentPlan.timeValues[index]) {
              periods.push(this.treatmentPlan.timeValues[index][prop]);
            }
            return {
              product: product.productName,
              periods,
              volumen: product.caldoMedium,
              price: product.price,
              unit_cost: parseFloat(product.unitCost),
              total_cost: parseFloat(product.totalCost),
              dosage_range: product.dosage_range,
            };
          }),
        };
        if (this.isPlantationSelected) {
          try {
            await treatmentPlanService.save(payload, this.currentPlantation.companyId);

            this.setOldPlantation(this.currentPlantation);
            if (this.currentPlanId) {
              this.$f7.views.main.router.navigate('/plans/', { reloadCurrent: true });
            } else {
              this.$f7.views.main.router.navigate('/searcher/treatment/', { reloadCurrent: true });
            }
          } catch (error) {
            this.$f7.dialog.alert(this.$t(`${error}`));
          }
          return;
        }

        try {
          if (this.treatmentPlan.id) {
            await treatmentPlanService.edit(this.treatmentPlan.id, payload, this.currentPlantation.companyId);
          } else {
            await treatmentPlanService.save(payload, this.currentPlantation.companyId);
          }
          this.$f7.views.main.router.navigate('/searcher/treatment/', { reloadCurrent: true });
        } catch (error) {
          this.$f7.dialog.alert(this.$t(`${error}`));
        }
      }
    },
    ...mapActions('Plantation', ['setOldPlantation']),
  },
};
